import { render, staticRenderFns } from "./CourtRecord.vue?vue&type=template&id=cf2d8e56&"
import script from "./CourtRecord.vue?vue&type=script&lang=js&"
export * from "./CourtRecord.vue?vue&type=script&lang=js&"
import style0 from "./CourtRecord.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports